// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.plugins-container {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
}

div.map-container {
    position: absolute;
}

div.map-buttons-container {
    position: absolute;
    pointer-events: none;
    display: flex;
    flex-direction: column-reverse;
    align-items: flex-start;
    align-content: flex-start;
    justify-content: flex-start;
    flex-wrap: wrap-reverse;
    z-index: 2;
    overflow: hidden;
    padding: 1.5em 1em 2.5em 1em;
}

div.map-buttons-spacer {
    display: inline-block;
    width: 1em;
    max-height: 4em;
    flex: 1 1 auto;
}`, "",{"version":3,"sources":["webpack://./components/style/PluginsContainer.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,yBAAyB;IACzB,2BAA2B;IAC3B,uBAAuB;IACvB,UAAU;IACV,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,eAAe;IACf,cAAc;AAClB","sourcesContent":["div.plugins-container {\n    position: absolute;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n}\n\ndiv.map-container {\n    position: absolute;\n}\n\ndiv.map-buttons-container {\n    position: absolute;\n    pointer-events: none;\n    display: flex;\n    flex-direction: column-reverse;\n    align-items: flex-start;\n    align-content: flex-start;\n    justify-content: flex-start;\n    flex-wrap: wrap-reverse;\n    z-index: 2;\n    overflow: hidden;\n    padding: 1.5em 1em 2.5em 1em;\n}\n\ndiv.map-buttons-spacer {\n    display: inline-block;\n    width: 1em;\n    max-height: 4em;\n    flex: 1 1 auto;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
